import { type ClientId, clientsConfig } from "~/config/clients.config";
import { isMobile } from "~/modules/support/clientId";
import { useGlobals } from "./useGlobals";

export const useClientId = () => {
  const { clientId } = useGlobals();

  const clientConfig =
    clientId in clientsConfig
      ? clientsConfig[clientId as ClientId]
      : clientsConfig.default;

  return {
    clientId: clientId ?? "",
    isMobile: isMobile(clientId),
    pages: clientConfig.pages,
    title: clientConfig.title,
  };
};
